<template>
  <div>
    <v-row>
      <v-col>
        <div class="ClosdTagLine__title">{{$t('login.ClosdTagLine.header')}}</div>
      </v-col>
    </v-row>
    <v-row align="center" class="mb-4">
      <v-col cols="auto">
        <img src="@/assets/img/icons/signature.svg" width="40" class="mr-3" alt="signature"/>
      </v-col>
      <v-col>
        <h3 class="ClosdTagLine__infoText">{{$t('login.ClosdTagLine.signature')}}</h3>
      </v-col>
    </v-row>
    <v-row align="center" class="mb-4">
      <v-col cols="auto">
        <img src="@/assets/img/icons/securite.svg" width="40" class="mr-3" alt="securite"/>
      </v-col>
      <v-col>
        <h3 class="ClosdTagLine__infoText">{{$t('login.ClosdTagLine.security')}}</h3>
      </v-col>
    </v-row>
    <v-row align="center" class="mb-4">
      <v-col cols="auto">
        <img src="@/assets/img/icons/document.svg" width="40" class="mr-3" alt="document"/>
      </v-col>
      <v-col>
        <h3 class="ClosdTagLine__infoText">{{$t('login.ClosdTagLine.project')}}</h3>
      </v-col>
    </v-row>
    <v-row class="mb-4">
      <v-col class="ClosdTagLine__infoText">{{$t('login.ClosdTagLine.paragraphOne')}}</v-col>
    </v-row>
    <v-row class="mb-4">
      <v-col class="ClosdTagLine__infoText">{{$t('login.ClosdTagLine.paragraphTwo')}}</v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'ClosdTagLine',
}
</script>

<style lang="scss" scoped>
.ClosdTagLine {
  &__title {
    font-size: 26px;
  }
  &__infoText {
    font-size: 16px;
    color: #515151;
  }
}
</style>
